import React from "react";
import Modal from "react-modal";
import Button from "../controls/button";
import PropTypes from "prop-types";
import Loader from '../icons/tat/loader';

Modal.setAppElement("#root");

class BaseDialog extends React.Component {
  handleClose = (e, reason) => {
    e.target.reason = reason;
    e.target.name = reason;
    this.props.closeAction(e);
  };
  handleAccept = (result) => {
    this.props.acceptAction(result);
  };

  render() {
    let isAcceptLoading = (this.props.isAcceptLoading !== null && this.props.isAcceptLoading);
    return (
      <Modal
        isOpen={this.props.open}
        portalClassName="dialog base-dialog"
        overlayClassName="overlay"
        className={"content ".concat(
          this.props.class || this.props.className
            ? this.props.class || this.props.className
            : ""
        )}
        style={this.props.style}
      >
        <div className="title">{this.props.title}</div>
        { 
          this.props.disableClose !== null && this.props.disableClose !== undefined && this.props.disableClose === true ? <div/> :
          <div
            className="close"
            onClick={(e) => this.handleClose(e, "close")}
          ></div>
        }
        <div className="message">
          {this.props.message}
          {this.props.contentObject}
        </div>
        <div className="actions">
          {this.props.showCancel ? (
            <Button
              settings={{
                text: this.props.cancelText,
                type: this.props.cancelButtonType,
                onClick: (e) => this.handleClose(e, "cancel"),
              }}
            />
          ) : (
            ""
          )}
          <Button
            settings={{
              text: isAcceptLoading ? <Loader/> : this.props.acceptText,
              disabled: isAcceptLoading || this.props.disabledAccept,
              type: this.props.acceptButtonType, 
              onClick: () => this.handleAccept(true),
            }}
          />
        </div>
      </Modal>
    );
  }
}

export default BaseDialog;

BaseDialog.propTypes = {
  closeAction: PropTypes.func,
  acceptAction: PropTypes.func,
  open: PropTypes.bool.isRequired,
  class: PropTypes.string,
  className: PropTypes.string,
  title: PropTypes.element,
  message: PropTypes.string,
  contentObject: PropTypes.element,
  showCancel: PropTypes.bool,
  cancelText: PropTypes.string,
  cancelButtonType: PropTypes.string,
  acceptText: PropTypes.string,
  disabledAccept: PropTypes.bool,
  style: PropTypes.object,
  acceptButtonType: PropTypes.string,
};

BaseDialog.defaultProps = {
  closeAction: () => {
    return false;
  },
  title: "",
  message: "",
  acceptText: "Continuar",
  acceptAction: () => {
    return true;
  },
  showCancel: false,
  cancelText: "Cancelar",
  disabledAccept: false,
  class: "",
  className: "",
  style: {},
  acceptButtonType: "primary",
  cancelButtonType: "primary",
};
